var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLockTraceability(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14712",
    "data-name": "Group 14712",
    transform: "translate(16660 -19976)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_20837",
    "data-name": "Path 20837",
    transform: "translate(-16660 19976)",
    fill: "#f3f6fa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6 11.5 C 2.967289924621582 11.5 0.5 9.032710075378418 0.5 6 C 0.5 2.967289924621582 2.967289924621582 0.5 6 0.5 C 9.032710075378418 0.5 11.5 2.967289924621582 11.5 6 C 11.5 9.032710075378418 9.032710075378418 11.5 6 11.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6 1 C 3.242989540100098 1 1 3.242989540100098 1 6 C 1 8.757009506225586 3.242989540100098 11 6 11 C 8.757009506225586 11 11 8.757009506225586 11 6 C 11 3.242989540100098 8.757009506225586 1 6 1 M 6 0 C 9.31371021270752 0 12 2.68628978729248 12 6 C 12 9.31371021270752 9.31371021270752 12 6 12 C 2.68628978729248 12 0 9.31371021270752 0 6 C 0 2.68628978729248 2.68628978729248 0 6 0 Z",
    stroke: "none",
    fill: "#203662"
  })), /*#__PURE__*/React.createElement("g", {
    id: "locked",
    transform: "translate(-16656.143 19979)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20834",
    "data-name": "Path 20834",
    d: "M9.857,4.571H9.429V3.286a1.286,1.286,0,1,0-2.571,0V4.571H6.429A.429.429,0,0,0,6,5V7.571A.429.429,0,0,0,6.429,8H9.857a.429.429,0,0,0,.429-.429V5A.429.429,0,0,0,9.857,4.571ZM7.286,3.286A.857.857,0,1,1,9,3.286V4.571H7.286Z",
    transform: "translate(-6 -2)",
    fill: "#203662"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockTraceability);
export default __webpack_public_path__ + "static/media/Lock-Traceability.3c571ba8d1693f572c4eea9af804e3b6.svg";
export { ForwardRef as ReactComponent };